import script from "./RotateArrow.vue?vue&type=script&setup=true&lang=ts"
export * from "./RotateArrow.vue?vue&type=script&setup=true&lang=ts"

import "./RotateArrow.vue?vue&type=style&index=0&id=a5ad0210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5ad0210"]])

export default __exports__